export default __webpack_public_path__ + "static/media/pdfPortfolioThumbnail.f7e68d90.svg";